//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

const URL = import.meta.env.VITE_API || `${window.location.origin}/api`;

export interface ICustomerVerificationClient {
	/**
	 * @param body (optional)
	 * @return OK
	 */
	verifyCustomer(body: VerifyCustomerQuery | undefined, cancelToken?: CancelToken): Promise<void>;
}

export class CustomerVerificationClient implements ICustomerVerificationClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * @param body (optional)
	 * @return OK
	 */
	verifyCustomer(body: VerifyCustomerQuery | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/CustomerVerification/VerifyCustomer';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processVerifyCustomer(_response);
			});
	}

	protected processVerifyCustomer(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}
}

export interface ICvMidTermAdjustmentClient {
	/**
	 * Gets or creates an MTA for commercial vehicle, if transaction id is not provided, a new MTA is started
	 * @param body (optional)
	 * @return OK
	 */
	getOrCreateCvMidTermAdjustment(
		body: GetOrCreateCvMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvMtaModel>;
	/**
     * Rates the MTA for commercial vehicle
     * @param body (optional) {
                PolicyReference
                MTARequestType from 
                }
     * @return OK
     */
	rateCvMidTermAdjustment(
		body: RateCvMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MidTermAdjustmentRatingResponse>;
}

export class CvMidTermAdjustmentClient implements ICvMidTermAdjustmentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Gets or creates an MTA for commercial vehicle, if transaction id is not provided, a new MTA is started
	 * @param body (optional)
	 * @return OK
	 */
	getOrCreateCvMidTermAdjustment(
		body: GetOrCreateCvMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<CvMtaModel> {
		let url_ = this.baseUrl + '/api/v1/CvMidTermAdjustment/GetOrCreateCvMidTermAdjustment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetOrCreateCvMidTermAdjustment(_response);
			});
	}

	protected processGetOrCreateCvMidTermAdjustment(response: AxiosResponse): Promise<CvMtaModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<CvMtaModel>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<CvMtaModel>(null as any);
	}

	/**
     * Rates the MTA for commercial vehicle
     * @param body (optional) {
                PolicyReference
                MTARequestType from 
                }
     * @return OK
     */
	rateCvMidTermAdjustment(
		body: RateCvMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MidTermAdjustmentRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/CvMidTermAdjustment/RateCvMidTermAdjustment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRateCvMidTermAdjustment(_response);
			});
	}

	protected processRateCvMidTermAdjustment(response: AxiosResponse): Promise<MidTermAdjustmentRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MidTermAdjustmentRatingResponse>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MidTermAdjustmentRatingResponse>(null as any);
	}
}

export interface IDocumentsClient {
	/**
	 * Get policy documents
	 * @param policyToken (optional) The policy token
	 * @return List of documents
	 */
	getLatestDocuments(policyToken: string | undefined, cancelToken?: CancelToken): Promise<DocumentDetails[]>;
	/**
	 * Get document content by document ID
	 * @param documentId (optional) Document Id: A URL Encoded Document identifier
	 * @return Document File
	 */
	getDocumentContent(documentId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse>;
}

export class DocumentsClient implements IDocumentsClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get policy documents
	 * @param policyToken (optional) The policy token
	 * @return List of documents
	 */
	getLatestDocuments(policyToken: string | undefined, cancelToken?: CancelToken): Promise<DocumentDetails[]> {
		let url_ = this.baseUrl + '/api/v1/Documents/GetLatestDocuments?';
		if (policyToken === null) throw new globalThis.Error("The parameter 'policyToken' cannot be null.");
		else if (policyToken !== undefined) url_ += 'policyToken=' + encodeURIComponent('' + policyToken) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetLatestDocuments(_response);
			});
	}

	protected processGetLatestDocuments(response: AxiosResponse): Promise<DocumentDetails[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<DocumentDetails[]>(result200);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('No documents found', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<DocumentDetails[]>(null as any);
	}

	/**
	 * Get document content by document ID
	 * @param documentId (optional) Document Id: A URL Encoded Document identifier
	 * @return Document File
	 */
	getDocumentContent(documentId: string | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
		let url_ = this.baseUrl + '/api/v1/Documents/GetDocumentContent?';
		if (documentId === null) throw new globalThis.Error("The parameter 'documentId' cannot be null.");
		else if (documentId !== undefined) url_ += 'documentId=' + encodeURIComponent('' + documentId) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			responseType: 'blob',
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetDocumentContent(_response);
			});
	}

	protected processGetDocumentContent(response: AxiosResponse): Promise<FileResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200 || status === 206) {
			const contentDisposition = response.headers ? response.headers['content-disposition'] : undefined;
			let fileNameMatch = contentDisposition
				? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
				: undefined;
			let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
			if (fileName) {
				fileName = decodeURIComponent(fileName);
			} else {
				fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
				fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
			}
			return Promise.resolve({
				fileName: fileName,
				status: status,
				data: new Blob([response.data], { type: response.headers['content-type'] as string | undefined }),
				headers: _headers,
			});
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('No document found', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FileResponse>(null as any);
	}
}

export interface IFeesClient {
	/**
	 * Get all fees data
	 * @return List of options
	 */
	getAllFeesListData(cancelToken?: CancelToken): Promise<AllFees>;
	/**
	 * Get Telematic Device Fee amount
	 * @return Admin fee requested
	 */
	getTelematicDeviceFee(cancelToken?: CancelToken): Promise<FeeItem>;
	/**
	 * Get Telematic Cradle Fee amount
	 * @return Admin fee requested
	 */
	getTelematicCradleFee(cancelToken?: CancelToken): Promise<FeeItem>;
	/**
	 * Get Telematic IMS Fee amount
	 * @return Admin fee requested
	 */
	getTelematicImsFee(cancelToken?: CancelToken): Promise<FeeItem>;
	/**
	 * Get Late Payment Fee amount
	 * @return Admin fee requested
	 */
	getLatePaymentFee(cancelToken?: CancelToken): Promise<FeeItem>;
}

export class FeesClient implements IFeesClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Get all fees data
	 * @return List of options
	 */
	getAllFeesListData(cancelToken?: CancelToken): Promise<AllFees> {
		let url_ = this.baseUrl + '/api/v1/Fees/GetAllFeesListData';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetAllFeesListData(_response);
			});
	}

	protected processGetAllFeesListData(response: AxiosResponse): Promise<AllFees> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<AllFees>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('Could not find the list of options.', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<AllFees>(null as any);
	}

	/**
	 * Get Telematic Device Fee amount
	 * @return Admin fee requested
	 */
	getTelematicDeviceFee(cancelToken?: CancelToken): Promise<FeeItem> {
		let url_ = this.baseUrl + '/api/v1/Fees/GetTelematicDeviceFee';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetTelematicDeviceFee(_response);
			});
	}

	protected processGetTelematicDeviceFee(response: AxiosResponse): Promise<FeeItem> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<FeeItem>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FeeItem>(null as any);
	}

	/**
	 * Get Telematic Cradle Fee amount
	 * @return Admin fee requested
	 */
	getTelematicCradleFee(cancelToken?: CancelToken): Promise<FeeItem> {
		let url_ = this.baseUrl + '/api/v1/Fees/GetTelematicCradleFee';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetTelematicCradleFee(_response);
			});
	}

	protected processGetTelematicCradleFee(response: AxiosResponse): Promise<FeeItem> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<FeeItem>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FeeItem>(null as any);
	}

	/**
	 * Get Telematic IMS Fee amount
	 * @return Admin fee requested
	 */
	getTelematicImsFee(cancelToken?: CancelToken): Promise<FeeItem> {
		let url_ = this.baseUrl + '/api/v1/Fees/GetTelematicImsFee';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetTelematicImsFee(_response);
			});
	}

	protected processGetTelematicImsFee(response: AxiosResponse): Promise<FeeItem> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<FeeItem>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FeeItem>(null as any);
	}

	/**
	 * Get Late Payment Fee amount
	 * @return Admin fee requested
	 */
	getLatePaymentFee(cancelToken?: CancelToken): Promise<FeeItem> {
		let url_ = this.baseUrl + '/api/v1/Fees/GetLatePaymentFee';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetLatePaymentFee(_response);
			});
	}

	protected processGetLatePaymentFee(response: AxiosResponse): Promise<FeeItem> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<FeeItem>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FeeItem>(null as any);
	}
}

export interface IMidTermAdjustmentClient {
	/**
	 * Retrieves details of the vehicle change position for the specified policy, are changes allowed, how many have been made and the maximum.
	 * @param policyToken Customer Policy Token
	 * @param startDate Policy Start Date
	 * @param endDate Policy End Date
	 * @param product Product
	 * @param scheme Scheme
	 * @return OK
	 */
	allowVehicleMTA(
		policyToken: string,
		startDate: string,
		endDate: string,
		product: Product,
		scheme: string,
		cancelToken?: CancelToken,
	): Promise<AllowVehicleChangeSummary>;
	/**
	 * Returns a list of policy MTAs filtered according to requestType
	 * @param policyToken (optional)
	 * @param requestType (optional)
	 * @return OK
	 */
	getPolicyMidTermAdjustments(
		policyToken: string | undefined,
		requestType: MTARequestType | undefined,
		cancelToken?: CancelToken,
	): Promise<MTASummary[]>;
	/**
	 * Take up MTA - Payment Method for MTA is sent
	 * @param body (optional)
	 * @return OK
	 */
	takeUpMidTermAdjustment(body: TakeUpMidTermAdjustmentCommand | undefined, cancelToken?: CancelToken): Promise<void>;
	/**
	 * Cancel an MTA
	 * @param policyReference Policy reference of MTA to cancel
	 * @param transactionId (MTA) Transaction reference to cancel
	 * @param cancellationReason Cancellation reason.
	 * @return OK
	 */
	cancelMidTermAdjustment(
		policyReference: string,
		transactionId: string,
		cancellationReason: MtaCancellationReason,
		cancelToken?: CancelToken,
	): Promise<void>;
}

export class MidTermAdjustmentClient implements IMidTermAdjustmentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Retrieves details of the vehicle change position for the specified policy, are changes allowed, how many have been made and the maximum.
	 * @param policyToken Customer Policy Token
	 * @param startDate Policy Start Date
	 * @param endDate Policy End Date
	 * @param product Product
	 * @param scheme Scheme
	 * @return OK
	 */
	allowVehicleMTA(
		policyToken: string,
		startDate: string,
		endDate: string,
		product: Product,
		scheme: string,
		cancelToken?: CancelToken,
	): Promise<AllowVehicleChangeSummary> {
		let url_ = this.baseUrl + '/api/v1/MidTermAdjustment/AllowVehicleMTA?';
		if (policyToken === undefined || policyToken === null)
			throw new globalThis.Error("The parameter 'policyToken' must be defined and cannot be null.");
		else url_ += 'PolicyToken=' + encodeURIComponent('' + policyToken) + '&';
		if (startDate === undefined || startDate === null)
			throw new globalThis.Error("The parameter 'startDate' must be defined and cannot be null.");
		else url_ += 'StartDate=' + encodeURIComponent('' + startDate) + '&';
		if (endDate === undefined || endDate === null)
			throw new globalThis.Error("The parameter 'endDate' must be defined and cannot be null.");
		else url_ += 'EndDate=' + encodeURIComponent('' + endDate) + '&';
		if (product === undefined || product === null)
			throw new globalThis.Error("The parameter 'product' must be defined and cannot be null.");
		else url_ += 'Product=' + encodeURIComponent('' + product) + '&';
		if (scheme === undefined || scheme === null)
			throw new globalThis.Error("The parameter 'scheme' must be defined and cannot be null.");
		else url_ += 'Scheme=' + encodeURIComponent('' + scheme) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processAllowVehicleMTA(_response);
			});
	}

	protected processAllowVehicleMTA(response: AxiosResponse): Promise<AllowVehicleChangeSummary> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<AllowVehicleChangeSummary>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<AllowVehicleChangeSummary>(null as any);
	}

	/**
	 * Returns a list of policy MTAs filtered according to requestType
	 * @param policyToken (optional)
	 * @param requestType (optional)
	 * @return OK
	 */
	getPolicyMidTermAdjustments(
		policyToken: string | undefined,
		requestType: MTARequestType | undefined,
		cancelToken?: CancelToken,
	): Promise<MTASummary[]> {
		let url_ = this.baseUrl + '/api/v1/MidTermAdjustment/GetPolicyMidTermAdjustments?';
		if (policyToken === null) throw new globalThis.Error("The parameter 'policyToken' cannot be null.");
		else if (policyToken !== undefined) url_ += 'policyToken=' + encodeURIComponent('' + policyToken) + '&';
		if (requestType === null) throw new globalThis.Error("The parameter 'requestType' cannot be null.");
		else if (requestType !== undefined) url_ += 'requestType=' + encodeURIComponent('' + requestType) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPolicyMidTermAdjustments(_response);
			});
	}

	protected processGetPolicyMidTermAdjustments(response: AxiosResponse): Promise<MTASummary[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MTASummary[]>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MTASummary[]>(null as any);
	}

	/**
	 * Take up MTA - Payment Method for MTA is sent
	 * @param body (optional)
	 * @return OK
	 */
	takeUpMidTermAdjustment(body: TakeUpMidTermAdjustmentCommand | undefined, cancelToken?: CancelToken): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/MidTermAdjustment/TakeUpMidTermAdjustment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processTakeUpMidTermAdjustment(_response);
			});
	}

	protected processTakeUpMidTermAdjustment(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}

	/**
	 * Cancel an MTA
	 * @param policyReference Policy reference of MTA to cancel
	 * @param transactionId (MTA) Transaction reference to cancel
	 * @param cancellationReason Cancellation reason.
	 * @return OK
	 */
	cancelMidTermAdjustment(
		policyReference: string,
		transactionId: string,
		cancellationReason: MtaCancellationReason,
		cancelToken?: CancelToken,
	): Promise<void> {
		let url_ = this.baseUrl + '/api/v1/MidTermAdjustment/CancelMidTermAdjustment?';
		if (policyReference === undefined || policyReference === null)
			throw new globalThis.Error("The parameter 'policyReference' must be defined and cannot be null.");
		else url_ += 'PolicyReference=' + encodeURIComponent('' + policyReference) + '&';
		if (transactionId === undefined || transactionId === null)
			throw new globalThis.Error("The parameter 'transactionId' must be defined and cannot be null.");
		else url_ += 'TransactionId=' + encodeURIComponent('' + transactionId) + '&';
		if (cancellationReason === undefined || cancellationReason === null)
			throw new globalThis.Error("The parameter 'cancellationReason' must be defined and cannot be null.");
		else url_ += 'CancellationReason=' + encodeURIComponent('' + cancellationReason) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'DELETE',
			url: url_,
			headers: {},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processCancelMidTermAdjustment(_response);
			});
	}

	protected processCancelMidTermAdjustment(response: AxiosResponse): Promise<void> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			return Promise.resolve<void>(null as any);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status === 423) {
			const _responseText = response.data;
			let result423: any = null;
			let resultData423 = _responseText;
			result423 = resultData423;
			return throwException('Locked', status, _responseText, _headers, result423);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<void>(null as any);
	}
}

export interface IPaymentClient {
	/**
	 * Create a Stripe payment intent
	 * @param body (optional) Take up and payment details
	 * @return Payment and policy take up successful
	 */
	makePaymentIntent(
		body: MakePaymentIntentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentIntentResponse>;
	/**
	 * Get client data (the caller's IP address) for the Braintree 3DS payload.
	 * @return Client data retrieved.
	 */
	getClientData(cancelToken?: CancelToken): Promise<GetClientDataResponse>;
}

export class PaymentClient implements IPaymentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Create a Stripe payment intent
	 * @param body (optional) Take up and payment details
	 * @return Payment and policy take up successful
	 */
	makePaymentIntent(
		body: MakePaymentIntentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentIntentResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/MakePaymentIntent';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakePaymentIntent(_response);
			});
	}

	protected processMakePaymentIntent(response: AxiosResponse): Promise<MakePaymentIntentResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentIntentResponse>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Validation error.', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MakePaymentIntentResponse>(null as any);
	}

	/**
	 * Get client data (the caller's IP address) for the Braintree 3DS payload.
	 * @return Client data retrieved.
	 */
	getClientData(cancelToken?: CancelToken): Promise<GetClientDataResponse> {
		let url_ = this.baseUrl + '/api/v1/Payment/GetClientData';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetClientData(_response);
			});
	}

	protected processGetClientData(response: AxiosResponse): Promise<GetClientDataResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetClientDataResponse>(result200);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetClientDataResponse>(null as any);
	}
}

export interface IPayNowClient {
	/**
	 * Generate Payment Token
	 * @param merchantAccount (optional)
	 * @return Braintree Token
	 */
	generatePaymentToken(merchantAccount: string | undefined, cancelToken?: CancelToken): Promise<string>;
	/**
	 * Make an initial payment
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makePayment(body: MakePaymentCommand | undefined, cancelToken?: CancelToken): Promise<MakePaymentResponseModel>;
	/**
	 * Make an initial payment via token
	 * @param token (optional)
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeTokenInitialPayment(
		token: string | undefined,
		body: MakePaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel>;
	/**
	 * Make a direct debit payment (Anonymous)
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeDirectDebitPayment(
		body: MakeDirectDebitPaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel>;
	/**
	 * Make an direct payment (Anonymous)
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeDirectPayment(
		body: MakeDirectPaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel>;
	/**
	 * Make an Outstanding Debt payment
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeOutstandingDebtPayment(
		body: MakeOutstandingDebtPaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel>;
	/**
	 * Finds Customer Payment details
	 * @param policyReference Policy Reference
	 * @return Password was set.
	 */
	getPaymentDetails(policyReference: string, cancelToken?: CancelToken): Promise<GetPaymentDetailsResponseModel>;
	/**
	 * Gets the list of payment collections for the defaulted direct debit
	 * @param body (optional)
	 * @return Password was set.
	 */
	getPaymentCollectionOptions(
		body: GetPaymentCollectionOptionsQuery | undefined,
		cancelToken?: CancelToken,
	): Promise<GetPaymentCollectionOptionsResponseModel[]>;
	/**
	 * Get Payment Details by Token (Anonymous)
	 * @param token Direct Link Token
	 * @return Payment details
	 */
	getPaymentDetailsByToken(token: string, cancelToken?: CancelToken): Promise<PaymentDetailsByTokenModel>;
	/**
	 * Get Agreement Details by Token (Anonymous)
	 * @param token Payment Token
	 * @return Agreement details
	 */
	getAgreementDetailsByToken(token: string, cancelToken?: CancelToken): Promise<GetAgreementDetailsResponseModel>;
}

export class PayNowClient implements IPayNowClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Generate Payment Token
	 * @param merchantAccount (optional)
	 * @return Braintree Token
	 */
	generatePaymentToken(merchantAccount: string | undefined, cancelToken?: CancelToken): Promise<string> {
		let url_ = this.baseUrl + '/api/v1/PayNow/GeneratePaymentToken?';
		if (merchantAccount === null) throw new globalThis.Error("The parameter 'merchantAccount' cannot be null.");
		else if (merchantAccount !== undefined) url_ += 'MerchantAccount=' + encodeURIComponent('' + merchantAccount) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGeneratePaymentToken(_response);
			});
	}

	protected processGeneratePaymentToken(response: AxiosResponse): Promise<string> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<string>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<string>(null as any);
	}

	/**
	 * Make an initial payment
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makePayment(body: MakePaymentCommand | undefined, cancelToken?: CancelToken): Promise<MakePaymentResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/MakePayment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakePayment(_response);
			});
	}

	protected processMakePayment(response: AxiosResponse): Promise<MakePaymentResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MakePaymentResponseModel>(null as any);
	}

	/**
	 * Make an initial payment via token
	 * @param token (optional)
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeTokenInitialPayment(
		token: string | undefined,
		body: MakePaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/MakeTokenInitialPayment?';
		if (token === null) throw new globalThis.Error("The parameter 'token' cannot be null.");
		else if (token !== undefined) url_ += 'token=' + encodeURIComponent('' + token) + '&';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakeTokenInitialPayment(_response);
			});
	}

	protected processMakeTokenInitialPayment(response: AxiosResponse): Promise<MakePaymentResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else {
			const _responseText = response.data;
			let resultdefault: any = null;
			let resultDatadefault = _responseText;
			resultdefault = resultDatadefault;
			return throwException('Error', status, _responseText, _headers, resultdefault);
		}
	}

	/**
	 * Make a direct debit payment (Anonymous)
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeDirectDebitPayment(
		body: MakeDirectDebitPaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/MakeDirectDebitPayment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakeDirectDebitPayment(_response);
			});
	}

	protected processMakeDirectDebitPayment(response: AxiosResponse): Promise<MakePaymentResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MakePaymentResponseModel>(null as any);
	}

	/**
	 * Make an direct payment (Anonymous)
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeDirectPayment(
		body: MakeDirectPaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/MakeDirectPayment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakeDirectPayment(_response);
			});
	}

	protected processMakeDirectPayment(response: AxiosResponse): Promise<MakePaymentResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MakePaymentResponseModel>(null as any);
	}

	/**
	 * Make an Outstanding Debt payment
	 * @param body (optional)
	 * @return Payment Result Details
	 */
	makeOutstandingDebtPayment(
		body: MakeOutstandingDebtPaymentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MakePaymentResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/MakeOutstandingDebtPayment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processMakeOutstandingDebtPayment(_response);
			});
	}

	protected processMakeOutstandingDebtPayment(response: AxiosResponse): Promise<MakePaymentResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MakePaymentResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MakePaymentResponseModel>(null as any);
	}

	/**
	 * Finds Customer Payment details
	 * @param policyReference Policy Reference
	 * @return Password was set.
	 */
	getPaymentDetails(policyReference: string, cancelToken?: CancelToken): Promise<GetPaymentDetailsResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/GetPaymentDetails?';
		if (policyReference === undefined || policyReference === null)
			throw new globalThis.Error("The parameter 'policyReference' must be defined and cannot be null.");
		else url_ += 'PolicyReference=' + encodeURIComponent('' + policyReference) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'POST',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPaymentDetails(_response);
			});
	}

	protected processGetPaymentDetails(response: AxiosResponse): Promise<GetPaymentDetailsResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetPaymentDetailsResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			return throwException('User not found.', status, _responseText, _headers);
		} else if (status === 409) {
			const _responseText = response.data;
			let result409: any = null;
			let resultData409 = _responseText;
			result409 = resultData409;
			return throwException(
				'Policy not in correct state. Expired, Pending or Overdue',
				status,
				_responseText,
				_headers,
				result409,
			);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetPaymentDetailsResponseModel>(null as any);
	}

	/**
	 * Gets the list of payment collections for the defaulted direct debit
	 * @param body (optional)
	 * @return Password was set.
	 */
	getPaymentCollectionOptions(
		body: GetPaymentCollectionOptionsQuery | undefined,
		cancelToken?: CancelToken,
	): Promise<GetPaymentCollectionOptionsResponseModel[]> {
		let url_ = this.baseUrl + '/api/v1/PayNow/GetPaymentCollectionOptions';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPaymentCollectionOptions(_response);
			});
	}

	protected processGetPaymentCollectionOptions(
		response: AxiosResponse,
	): Promise<GetPaymentCollectionOptionsResponseModel[]> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetPaymentCollectionOptionsResponseModel[]>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetPaymentCollectionOptionsResponseModel[]>(null as any);
	}

	/**
	 * Get Payment Details by Token (Anonymous)
	 * @param token Direct Link Token
	 * @return Payment details
	 */
	getPaymentDetailsByToken(token: string, cancelToken?: CancelToken): Promise<PaymentDetailsByTokenModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/GetPaymentDetailsByToken?';
		if (token === undefined || token === null)
			throw new globalThis.Error("The parameter 'token' must be defined and cannot be null.");
		else url_ += 'Token=' + encodeURIComponent('' + token) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPaymentDetailsByToken(_response);
			});
	}

	protected processGetPaymentDetailsByToken(response: AxiosResponse): Promise<PaymentDetailsByTokenModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PaymentDetailsByTokenModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			return throwException('Payment details not found', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PaymentDetailsByTokenModel>(null as any);
	}

	/**
	 * Get Agreement Details by Token (Anonymous)
	 * @param token Payment Token
	 * @return Agreement details
	 */
	getAgreementDetailsByToken(token: string, cancelToken?: CancelToken): Promise<GetAgreementDetailsResponseModel> {
		let url_ = this.baseUrl + '/api/v1/PayNow/GetAgreementDetailsByToken?';
		if (token === undefined || token === null)
			throw new globalThis.Error("The parameter 'token' must be defined and cannot be null.");
		else url_ += 'Token=' + encodeURIComponent('' + token) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetAgreementDetailsByToken(_response);
			});
	}

	protected processGetAgreementDetailsByToken(response: AxiosResponse): Promise<GetAgreementDetailsResponseModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<GetAgreementDetailsResponseModel>(result200);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 401) {
			const _responseText = response.data;
			let result401: any = null;
			let resultData401 = _responseText;
			result401 = resultData401;
			return throwException('Unauthorized', status, _responseText, _headers, result401);
		} else if (status === 404) {
			const _responseText = response.data;
			return throwException('Agreement details not found', status, _responseText, _headers);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<GetAgreementDetailsResponseModel>(null as any);
	}
}

export interface IPcMidTermAdjustmentClient {
	/**
	 * Gets or creates the MTA for private car, if transaction id is not, a new MTA started
	 * @param body (optional)
	 * @return OK
	 */
	getOrCreatePcMidTermAdjustment(
		body: GetOrCreatePcMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PcMtaModel>;
	/**
     * Rates the MTA for private car
     * @param body (optional) {
                PolicyReference
                MTARequestType from 
                }
     * @return OK
     */
	ratePcMidTermAdjustment(
		body: RatePcMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MidTermAdjustmentRatingResponse>;
}

export class PcMidTermAdjustmentClient implements IPcMidTermAdjustmentClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Gets or creates the MTA for private car, if transaction id is not, a new MTA started
	 * @param body (optional)
	 * @return OK
	 */
	getOrCreatePcMidTermAdjustment(
		body: GetOrCreatePcMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<PcMtaModel> {
		let url_ = this.baseUrl + '/api/v1/PcMidTermAdjustment/GetOrCreatePcMidTermAdjustment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetOrCreatePcMidTermAdjustment(_response);
			});
	}

	protected processGetOrCreatePcMidTermAdjustment(response: AxiosResponse): Promise<PcMtaModel> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PcMtaModel>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PcMtaModel>(null as any);
	}

	/**
     * Rates the MTA for private car
     * @param body (optional) {
                PolicyReference
                MTARequestType from 
                }
     * @return OK
     */
	ratePcMidTermAdjustment(
		body: RatePcMidTermAdjustmentCommand | undefined,
		cancelToken?: CancelToken,
	): Promise<MidTermAdjustmentRatingResponse> {
		let url_ = this.baseUrl + '/api/v1/PcMidTermAdjustment/RatePcMidTermAdjustment';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = body;

		let options_: AxiosRequestConfig = {
			data: content_,
			method: 'PUT',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processRatePcMidTermAdjustment(_response);
			});
	}

	protected processRatePcMidTermAdjustment(response: AxiosResponse): Promise<MidTermAdjustmentRatingResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<MidTermAdjustmentRatingResponse>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<MidTermAdjustmentRatingResponse>(null as any);
	}
}

export interface IPoliciesClient {
	/**
	 * Gets a list of active policies associated with a customer
	 * @param renewalFilter (optional)
	 * @param product (optional)
	 * @return OK
	 */
	getPolicyOverviews(
		fetchStartIndex: number,
		fetchSize: number,
		renewalFilter: boolean | undefined,
		product: Product | undefined,
		cancelToken?: CancelToken,
	): Promise<PolicyOverviewResponse>;
	/**
	 * Get a full policy for reference
	 * @param policyToken (optional)
	 * @return OK
	 */
	getPolicy(policyToken: string | undefined, cancelToken?: CancelToken): Promise<FullPolicy>;
	/**
	 * Gets policy status by reference
	 * @param policyReference (optional)
	 * @return OK
	 */
	getPolicyStatusByReference(policyReference: string | undefined, cancelToken?: CancelToken): Promise<PolicyStatus>;
}

export class PoliciesClient implements IPoliciesClient {
	protected instance: AxiosInstance;
	protected baseUrl: string;
	protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

	constructor(baseUrl?: string, instance?: AxiosInstance) {
		this.instance = instance || axios.create();

		this.baseUrl = baseUrl ?? URL;
	}

	/**
	 * Gets a list of active policies associated with a customer
	 * @param renewalFilter (optional)
	 * @param product (optional)
	 * @return OK
	 */
	getPolicyOverviews(
		fetchStartIndex: number,
		fetchSize: number,
		renewalFilter: boolean | undefined,
		product: Product | undefined,
		cancelToken?: CancelToken,
	): Promise<PolicyOverviewResponse> {
		let url_ = this.baseUrl + '/api/v1/Policies/GetPolicyOverviews?';
		if (fetchStartIndex === undefined || fetchStartIndex === null)
			throw new globalThis.Error("The parameter 'fetchStartIndex' must be defined and cannot be null.");
		else url_ += 'FetchStartIndex=' + encodeURIComponent('' + fetchStartIndex) + '&';
		if (fetchSize === undefined || fetchSize === null)
			throw new globalThis.Error("The parameter 'fetchSize' must be defined and cannot be null.");
		else url_ += 'FetchSize=' + encodeURIComponent('' + fetchSize) + '&';
		if (renewalFilter === null) throw new globalThis.Error("The parameter 'renewalFilter' cannot be null.");
		else if (renewalFilter !== undefined) url_ += 'RenewalFilter=' + encodeURIComponent('' + renewalFilter) + '&';
		if (product === null) throw new globalThis.Error("The parameter 'product' cannot be null.");
		else if (product !== undefined) url_ += 'Product=' + encodeURIComponent('' + product) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPolicyOverviews(_response);
			});
	}

	protected processGetPolicyOverviews(response: AxiosResponse): Promise<PolicyOverviewResponse> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PolicyOverviewResponse>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PolicyOverviewResponse>(null as any);
	}

	/**
	 * Get a full policy for reference
	 * @param policyToken (optional)
	 * @return OK
	 */
	getPolicy(policyToken: string | undefined, cancelToken?: CancelToken): Promise<FullPolicy> {
		let url_ = this.baseUrl + '/api/v1/Policies/GetPolicy?';
		if (policyToken === null) throw new globalThis.Error("The parameter 'policyToken' cannot be null.");
		else if (policyToken !== undefined) url_ += 'policyToken=' + encodeURIComponent('' + policyToken) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPolicy(_response);
			});
	}

	protected processGetPolicy(response: AxiosResponse): Promise<FullPolicy> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<FullPolicy>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<FullPolicy>(null as any);
	}

	/**
	 * Gets policy status by reference
	 * @param policyReference (optional)
	 * @return OK
	 */
	getPolicyStatusByReference(policyReference: string | undefined, cancelToken?: CancelToken): Promise<PolicyStatus> {
		let url_ = this.baseUrl + '/api/v1/Policies/GetPolicyStatusByReference?';
		if (policyReference === null) throw new globalThis.Error("The parameter 'policyReference' cannot be null.");
		else if (policyReference !== undefined) url_ += 'policyReference=' + encodeURIComponent('' + policyReference) + '&';
		url_ = url_.replace(/[?&]$/, '');

		let options_: AxiosRequestConfig = {
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'application/json',
			},
			cancelToken,
		};

		return this.instance
			.request(options_)
			.catch((_error: any) => {
				if (isAxiosError(_error) && _error.response) {
					return _error.response;
				} else {
					throw _error;
				}
			})
			.then((_response: AxiosResponse) => {
				return this.processGetPolicyStatusByReference(_response);
			});
	}

	protected processGetPolicyStatusByReference(response: AxiosResponse): Promise<PolicyStatus> {
		const status = response.status;
		let _headers: any = {};
		if (response.headers && typeof response.headers === 'object') {
			for (const k in response.headers) {
				if (response.headers.hasOwnProperty(k)) {
					_headers[k] = response.headers[k];
				}
			}
		}
		if (status === 200) {
			const _responseText = response.data;
			let result200: any = null;
			let resultData200 = _responseText;
			result200 = resultData200;
			return Promise.resolve<PolicyStatus>(result200);
		} else if (status === 204) {
			const _responseText = response.data;
			return throwException('No Content', status, _responseText, _headers);
		} else if (status === 400) {
			const _responseText = response.data;
			let result400: any = null;
			let resultData400 = _responseText;
			result400 = resultData400;
			return throwException('Bad Request', status, _responseText, _headers, result400);
		} else if (status === 404) {
			const _responseText = response.data;
			let result404: any = null;
			let resultData404 = _responseText;
			result404 = resultData404;
			return throwException('Not Found', status, _responseText, _headers, result404);
		} else if (status !== 200 && status !== 204) {
			const _responseText = response.data;
			return throwException('An unexpected server error occurred.', status, _responseText, _headers);
		}
		return Promise.resolve<PolicyStatus>(null as any);
	}
}

export enum PaymentProvider {
	STRIPE = 'STRIPE',
	BRAINTREE = 'BRAINTREE',
}

export enum PreparePaymentSource {
	CARD = 'CARD',
	WALLET = 'WALLET',
}

export enum Product {
	PRIVATE_CAR = 'PRIVATE_CAR',
	COMMERCIAL_VEHICLE = 'COMMERCIAL_VEHICLE',
	TELEMATICS = 'TELEMATICS',
	TAXI = 'TAXI',
	CARROT = 'CARROT',
	HOUSEHOLD = 'HOUSEHOLD',
}

export interface VerifyCustomerQuery {
	dob?: string | undefined;
	vehicleRegistrationNumber?: string | undefined;
}

export interface GetOrCreateCvMidTermAdjustmentCommand {
	/** The Policy Reference */
	policyReference: string;
	/** The date for when the MTA starts */
	mtaStartDate: string;
	/** List of changes associated to the MTA */
	changeType: MtaChangeType[];
	/** This is the transaction id for the MTA */
	transactionId?: string | undefined;
}

export interface RateCvMidTermAdjustmentCommand {
	/** The Policy Reference */
	policyReference: string;
	/** The date for when the MTA starts */
	mtaStartDate: string;
	/** List of changes associated to the MTA */
	changeType: MtaChangeType[];
	midTermAdjustment: CvMtaModel;
}

export interface GetOrCreatePcMidTermAdjustmentCommand {
	/** The Policy Reference */
	policyReference: string;
	/** The date for when the MTA starts */
	mtaStartDate: string;
	/** List of changes associated to the MTA */
	changeType: MtaChangeType[];
	/** This is the transaction id for the MTA */
	transactionId?: string | undefined;
}

export interface RatePcMidTermAdjustmentCommand {
	/** The Policy Reference */
	policyReference: string;
	/** The date for when the MTA starts */
	mtaStartDate: string;
	/** List of changes associated to the MTA */
	changeType: MtaChangeType[];
	midTermAdjustment: PcMtaModel;
}

export interface MakeDirectDebitPaymentCommand {
	paymentNonce: string;
	deviceData: string;
	amount: number;
	directDebitId: string;
	threeDSecureAuthenticationId: string;
	token?: string | undefined;
	vaultCard?: boolean;
}

export interface MakeDirectPaymentCommand {
	paymentNonce: string;
	deviceData: string;
	amount: number;
	splitPaymentId: string;
	threeDSecureAuthenticationId: string;
	token?: string | undefined;
}

export interface MakeOutstandingDebtPaymentCommand {
	paymentNonce?: string | undefined;
	deviceData?: string | undefined;
	amount?: number;
	vendorTXCode?: string | undefined;
	threeDSecureAuthenticationId?: string | undefined;
	emailAddress?: string | undefined;
	vaultCard?: boolean;
	agreementId?: string;
}

export interface MakePaymentCommand {
	paymentNonce?: string | undefined;
	deviceData?: string | undefined;
	amount?: number;
	vendorTXCode?: string | undefined;
	directDebitId?: string;
	paymentPlanType?: PaymentPlanType;
	threeDSecureAuthenticationId?: string | undefined;
	emailAddress?: string | undefined;
	vaultCard?: boolean;
}

export interface MakePaymentResponseModel {
	readonly isSuccessful: boolean;
	paymentResponse: PaymentResponseType;
}

export enum PaymentResponseType {
	Successful = 'Successful',
	InvalidCardDetails = 'InvalidCardDetails',
	InvalidFraudPrevention = 'InvalidFraudPrevention',
	SplitPaymentNotFound = 'SplitPaymentNotFound',
	DirectDebitNotFound = 'DirectDebitNotFound',
	PaymentAlreadyExists = 'PaymentAlreadyExists',
	AmountRequestDoesNotMatchAmountDue = 'AmountRequestDoesNotMatchAmountDue',
	PaymentPlanAlreadySetup = 'PaymentPlanAlreadySetup',
	PolicyCancelled = 'PolicyCancelled',
	AgreementNotFound = 'AgreementNotFound',
	TokenNotFound = 'TokenNotFound',
	InsufficientFunds = 'InsufficientFunds',
	CardPaymentDeclined = 'CardPaymentDeclined',
	UnknownError = 'UnknownError',
}

export interface GetAgreementDetailsResponseModel {
	agreementId?: string | undefined;
	directDebitId?: string | undefined;
	agreementReference: string;
	policyDetailsId: string;
	status: PayNowStatus;
	policyIsCancelled: boolean;
	policyIsExpired: boolean;
	hasExpiredSplitPaymentPlan: boolean;
	validUntil: string;
	missedPaymentDetails: MissedPaymentModel;
	splitPaymentPlans?: SplitPaymentPlanModel[] | undefined;
	product?: string | undefined;
	scheme?: string | undefined;
}

export interface GetPaymentCollectionOptionsResponseModel {
	paymentPlanType: PaymentPlanType;
	readonly totalAmount: number;
	missedPaymentAmount: number;
	fee?: number | undefined;
	installments: PaymentInstallmentsMessageModel[];
}

export interface GetPaymentDetailsResponseModel {
	status: PayNowStatus;
	policyDetailsId: string;
	policyHolderFirstName: string;
	policyHolderLastName: string;
	policyHolderCompanyName: string;
	policyReference: string;
	agreementReference: string;
	totalBalanceOutstanding: number;
	agreementId: string;
	amountDueOnNextDirectDebit: number;
	policyIsCancelled: boolean;
	nextDirectDebitDue?: string | undefined;
	nextDirectDebitScheduled?: string | undefined;
	email: string;
	customerId: string;
	unaccountedForBalance: number;
	withDebtCollection?: string | undefined;
	missedPaymentDetails?: MissedPaymentModel;
	splitPaymentPlans: SplitPaymentPlanModel[];
	overDuePaymentPlan?: SplitPaymentPlanModel;
	currentPaymentPlanVersion?: number;
}

export interface MissedPaymentModel {
	missedPaymentDate: string;
	initialAmount: number;
	amountToPay: number;
	adminFee?: number;
	directDebitId: string;
	readonly isOverduePayment: boolean;
	iceCollectionReference: string;
}

export interface PaymentDetailsByTokenModel {
	amount: number;
	splitPaymentId: string;
	customerId: string;
	agreementId: string;
	emailAddress: string;
	validUntil: string;
	directDebitId?: string | undefined;
}

export interface SplitPaymentPlanModel {
	splitPaymentId: string;
	dateOfPayment: string;
	amount: number;
	status: SplitPaymentStatus;
	isConsolidated: boolean;
}

export enum SplitPaymentStatus {
	Pending = 'Pending',
	Overdue = 'Overdue',
	Paid = 'Paid',
}

export interface GetPaymentCollectionOptionsQuery {
	defaultedDirectDebitId: string;
}

export interface MakePaymentIntentCommand {
	/** Quote Reference */
	policyReference: string;
	paymentDetails: PaymentDetails;
	/** The transaction id associated with the payment */
	transactionId: string;
	transactionType: TransactionType;
	paymentProvider?: PaymentProvider;
	/** The source of the prepared payment. WALLET for a wallet payment (e.g. PayPal), otherwise CARD. */
	preparePaymentSource?: PreparePaymentSource;
}

export interface TakeUpMidTermAdjustmentCommand {
	/** Policy Reference */
	policyReference: string;
	/** The transaction id associated with the payment */
	transactionId: string;
	takeUpDetails: TakeUpDetails;
	/** Payment Id from the make payment intent endpoint */
	paymentId?: string | undefined;
	/** This comes from the Stripe authorization call. */
	authorizationId?: string | undefined;
	/** This is an existing payment method id (selected for an existing card). */
	existingCardPaymentMethodId?: string | undefined;
	/** Used to send postal documents */
	sendPostalDocuments?: boolean;
}

export enum CardVendor {
	Visa = 'Visa',
	Mastercard = 'Mastercard',
	Other = 'Other',
}

export enum FeeType {
	TelematicDeviceFee = 'TelematicDeviceFee',
	TelematicCradleFee = 'TelematicCradleFee',
	TelematicImsFee = 'TelematicImsFee',
	LatePaymentFee = 'LatePaymentFee',
}

export enum MTARequestType {
	All = 'All',
	RequestedAndAccepted = 'RequestedAndAccepted',
	RecentlyRequestedAndAccepted = 'RecentlyRequestedAndAccepted',
}

export enum MtaCancellationReason {
	ERROR = 'ERROR',
	CLIENTDECISION = 'CLIENTDECISION',
	INCORRECTTERMS = 'INCORRECTTERMS',
}

export enum MtaChangeType {
	CHANGE_VEHICLE = 'CHANGE_VEHICLE',
	CHANGE_ADDRESS = 'CHANGE_ADDRESS',
	CHANGE_DRIVER = 'CHANGE_DRIVER',
	CHANGE_USAGE_AND_MILEAGE = 'CHANGE_USAGE_AND_MILEAGE',
	CHANGE_VEHICLE_AND_COVER = 'CHANGE_VEHICLE_AND_COVER',
	TOP_UP_MILES = 'TOP_UP_MILES',
}

export enum PayNowStatus {
	CancelledWithoutDebt = 'CancelledWithoutDebt',
	CancelledWithDebt = 'CancelledWithDebt',
	SplitPaymentOverdue = 'SplitPaymentOverdue',
	DirectDebitOverdue = 'DirectDebitOverdue',
	ActivePaymentSchedule = 'ActivePaymentSchedule',
	WithDebtCollectors = 'WithDebtCollectors',
	ConsolidatedPaymentSchedule = 'ConsolidatedPaymentSchedule',
	CompletedPaymentSchedule = 'CompletedPaymentSchedule',
}

export enum PaymentMethods {
	CARD_PAYMENT = 'CARD_PAYMENT',
	DIRECT_DEBIT = 'DIRECT_DEBIT',
}

export enum PolicyDocumentType {
	CERTIFICATE = 'CERTIFICATE',
	SCHEDULE = 'SCHEDULE',
	SOF = 'SOF',
	TOBA = 'TOBA',
	IPID = 'IPID',
	POLICY_WORDING = 'POLICY_WORDING',
	CANCELLATION_PACK = 'CANCELLATION_PACK',
}

export enum TransactionType {
	MidTermAdjustment = 'MidTermAdjustment',
}

export interface Address {
	/** UK Post code */
	postcode: string;
	/** House Number or Name */
	line1: string;
	/** Extra address line 1 */
	line2?: string | undefined;
	/** Extra address line 2 */
	line3?: string | undefined;
	/** Extra address line 3 */
	line4?: string | undefined;
	/** City */
	city: string;
	/** County */
	county?: string | undefined;
	/** Country code */
	country?: string | undefined;
}

export interface LicenceRestriction {
	licenceRestrictionsId?: string | undefined;
}

export interface MotoringClaim {
	/** Claim number. */
	claimNumber?: string | undefined;
	/** Accidental damage costs. */
	adCosts?: number | undefined;
	/** Date of claim */
	dateOfClaim: string;
	/** Date of incident */
	incidentDate?: string | undefined;
	/** Claim Type */
	typeOfClaim: string;
	/** Status */
	statusOfClaim: string;
	/** Driver at fault */
	atFault: boolean;
	/** No Claims Bonus */
	noClaimsBonusAffected: boolean;
	/** Personal Injury */
	personalInjury?: boolean | undefined;
	/** Cost of the claim */
	costOfClaim: number;
	/** Vehicle registration number. */
	vehicleRegistrationNumber?: string | undefined;
	/** Risk class. */
	riskClass?: string | undefined;
	/** Driver Full Name */
	driverFullName?: string | undefined;
}

export interface MotoringConviction {
	/** Date of conviction */
	dateOfConviction?: string | undefined;
	/** Date of conviction */
	dateOfOffence: string;
	/** ABI023 Code */
	offenceCode: string;
	/** Was the driver disqualified */
	wasDisqualified: boolean;
	/** Disqualified start date */
	banStartDate?: string | undefined;
	/** Disqualified end date */
	banEndDate?: string | undefined;
	/** Points on licence */
	numberOfPoints?: number | undefined;
	/** Fine for conviction */
	fineAmount?: number | undefined;
	/** Conviction still pending */
	isPending?: boolean | undefined;
}

export interface DocumentDetails {
	/** ID of the policy to be used by get document content endpoint */
	id: string;
	/** File name of document */
	fileName: string;
	/** File size of the document */
	fileSize: number;
	documentType: PolicyDocumentType;
	/** The name of the document type */
	description: string;
	/** When the document was generated */
	created: string;
	/** The associated transaction id the document was generated for */
	transactionId: string;
}

export interface DriverDetails {
	/** Title of Driver */
	title: string;
	/** Driver first name */
	firstName: string;
	/** Driver last name */
	lastName: string;
	/** Is this driver a policyholder
<value>true</value><example>true</example> */
	isPolicyholder: boolean;
	/** Is main driver of vehicle */
	mainDriver: boolean;
	/** This is the ICE data point id for the driver */
	dataPointId: string;
	badgePassedDate?: string | undefined;
	badgeHeldYears?: number | undefined;
	driverUsage?: string | undefined;
	/** Does the driver have any claims on their policy. */
	hasClaims?: boolean;
}

export interface AllFees {
	feeData?: FeeItem[] | undefined;
}

export interface FeeItem {
	type: FeeType;
	/** This is fee value */
	value: number;
}

export interface AllowVehicleChangeSummary {
	allowed?: boolean;
	acceptedVehicleChanges?: number;
	maxVehicleChanges?: number;
}

export interface CoverDetails {
	endorsements?: Endorsement[] | undefined;
	fee: number;
	voluntaryExcess: number;
	compulsoryExcess: number;
	driverExcesses: DriverExcess[];
	operatingArea?: string | undefined;
}

export interface CvMtaModel {
	vehicleDetails: CommercialVehicleDetails;
	/** This is the transaction id for the MTA */
	transactionId: string;
	policyDetails: PolicyDetails;
	/** The existing or edited additional drivers */
	drivers: DriverDetails2[];
	/** If set to true, the MTa period is invalid and we cannot process */
	invalidMtaStartDate: boolean;
}

export interface DriverDetails2 {
	/** Either this is the existing data point id
this needs to be updated so we can match and update the correct information */
	dataPointId?: string | undefined;
	/** Relationship to policy proposer */
	relationshipToProposer: string;
	/** Title of Driver */
	title: string;
	/** Driver first name */
	firstName: string;
	/** Driver last names */
	lastNames: string;
	/** Date of birth of driver */
	dateOfBirth: string;
	/** Marital Status of driver */
	maritalStatus: string;
	/** Is Driver UK resident from birth */
	isResidentFromBirth: boolean;
	/** Uk residence since if not birth */
	ukResidenceSince?: string | undefined;
	/** Employment Type code */
	employmentType: string;
	/** Occupation code */
	occupation?: string | undefined;
	/** Industry code */
	industry?: string | undefined;
	/** Occupation code */
	otherOccupation?: string | undefined;
	/** Industry code */
	otherIndustry?: string | undefined;
	/** Is main driver of vehicle */
	isMainDriver: boolean;
	/** Licence type code */
	licenceType: string;
	/** UK driver LicenceNumber */
	licenceNumber?: string | undefined;
	/** Licence Obtained date */
	licenceObtained: string;
	/** Convicted motor criminal check */
	hasCriminalConvictions: boolean;
	/** Refused cover check */
	hasBeenRefusedCover: boolean;
	/** Access to other vehicles */
	accessToOtherVehicles: boolean;
	/** Number of other owned */
	numberOfVehiclesOwned?: number | undefined;
	/** Number of other vehicles access to */
	numberOfVehiclesAccessTo?: number | undefined;
	/** Telephone number */
	phoneNumber?: string | undefined;
	/** PartType of the driver */
	partyType?: string | undefined;
	/** List of motoring convictions */
	motoringConvictions?: MotoringConviction[] | undefined;
	/** Licence restrictions (cv alows more than one) */
	licenceRestrictions?: LicenceRestriction[] | undefined;
	/** Licence Restrictions Id code (only one in pc) */
	licenceRestrictionsId?: string | undefined;
	/** List of motoring claims */
	motoringClaims?: MotoringClaim[] | undefined;
	/** Date badge passed / obtained */
	badgePassedDate?: string | undefined;
	/** Number of years badge has been held */
	badgeHeldYears?: number | undefined;
	/** Driver usage */
	driverUsage?: string | undefined;
	employmentStatus?: string | undefined;
	otherEmploymentStatus?: string | undefined;
	otherEmploymentType?: string | undefined;
}

export interface DriverExcess {
	compulsoryAmount: number;
	dataPointId: string;
}

export interface Endorsement {
	name?: string | undefined;
	description?: string | undefined;
}

export interface MTASummary {
	transactionId: string;
	changeType: string[];
	changeDate: string;
	transactionStatus: string;
}

export interface MidTermAdjustmentRatingResponse {
	optionId: string;
	underwritingOutcomeResponseId: string;
	transactionId: string;
	paymentOptions: MtaPaymentCollectionOption[];
	mtaResponse: MtaResponse;
	hasDeclined: boolean;
	declineReason?: string | undefined;
	coverDetails: CoverDetails;
	existingCardPaymentMethods: ExistingCardPaymentMethod[];
	drivers: DriverDetails[];
	paymentProvider: PaymentProvider2;
}

export interface MtaPaymentCollectionOption {
	code: string;
	unequalInstalmentAmount?: number | undefined;
	standardInstalmentAmount?: number | undefined;
	totalAmountPayable?: number | undefined;
	appliedInstalmentCount?: number | undefined;
}

export enum MtaResponse {
	Pending = 'Pending',
	Underwritten = 'Underwritten',
	Referred = 'Referred',
	TakenUp = 'TakenUp',
	NotTakenUp = 'NotTakenUp',
	Expired = 'Expired',
}

export interface PcMtaModel {
	vehicleDetails: VehicleDetails;
	/** This is the transaction id for the MTA */
	transactionId: string;
	policyDetails: PolicyDetails;
	/** The existing or edited additional drivers */
	drivers: DriverDetails2[];
	/** If set to true, the MTa period is invalid and we cannot process */
	invalidMtaStartDate: boolean;
}

export interface ContinuousAuthorityRepresentitive {
	representativeAuthorityExpiryDate?: string | undefined;
	representativeAuthorityLevel?: string | undefined;
	representativeName?: string | undefined;
	representativeRelationship?: string | undefined;
}

export interface PolicyDetails {
	policyholder: Policyholder;
	operatingArea?: string | undefined;
	continuousAuthority?: ContinuousAuthorityRepresentitive[] | undefined;
}

export interface Policyholder {
	address: Address;
	/** Is home owner */
	isHomeOwner: boolean;
}

export interface CommercialVehicleDetails {
	/** Business Radius */
	businessRadius: string;
	/** Vehicle has internal racking */
	hasInternalRacking: boolean;
	/** Vehicle carries dangerous goods */
	vehicleCarriesDangerousGoods: boolean;
	/** Does the vehicle visit any hazardous sites */
	vehicleVisitsHazardousSites: boolean;
	/** Abi Code of vehicle */
	abiCode: string;
	/** Abi group for the vehicle */
	abiGroup: number;
	/** Annual mileage */
	annualMileage: number;
	/** Annual business mileage */
	businessMileage: number;
	/** Car body type code */
	bodyType: string;
	/** UK Vehicle Registration */
	registration: string;
	/** Vehicle Make */
	make: string;
	/** Vehicle Model */
	model: string;
	/** Number of doors on vehicle */
	numberOfDoors: string;
	/** Vehicle fuel type */
	fuelType: string;
	/** Transmission type */
	transmission: string;
	/** Gross Weight */
	grossWeight?: number;
	/** Cylinder capacity of engine */
	engineSize: number;
	/** Estimated value of vehicle */
	value: number;
	/** See vehicle lookup year */
	yearOfManufacture: number;
	/** Is left hand drive */
	isLeftHandDrive?: boolean;
	/** Date of vehicle purchase */
	datePurchased?: string;
	/** DVLA issues ‘Q’ registration numbers to vehicles whose age or identity is in doubt. */
	isQPlate?: boolean;
	/** Has the vehicle been imported from overseas */
	isImported?: boolean;
	/** Vehicle Use code */
	vehicleUse: string;
	/** See vehicle owner code */
	ownership: string;
	/** See vehicle keeper code */
	registeredKeeper: string;
	/** Date Vehicle was registed */
	registrationDate: string;
	/** Country of Registration */
	countryOfRegistration?: string | undefined;
	/** Number of seats */
	numberOfSeats: string;
	/** See vehicle storage codes */
	vehicleOvernight: string;
	overnightAddress?: Address;
	/** List of modifications */
	modifications?: Modification[] | undefined;
	/** List of security devices */
	securityDevices?: SecurityDevice[] | undefined;
	/** Selected Cover */
	coverDefinitionCode?: string | undefined;
	/** Telematic Device Information. */
	telematicsDeviceInformation?: string | undefined;
	/** Has Telematic Box */
	telematicsBox?: boolean;
	/** Licensing Authority Information */
	licencingAuthority?: string | undefined;
	/** Deliver operator i.e  Uber Eats */
	deliveryOperator?: string | undefined;
}

export interface Modification {
	/** Vehicle Modification Code */
	modificationCode: string;
	/** Details of modication */
	details?: string | undefined;
	/** Value of modification */
	value: number;
	/** Medical Reasons */
	isForMedicalReasons: boolean;
	/** Current issuer knows of modification */
	isCurrentInsurerNotified: boolean;
}

export interface SecurityDevice {
	/** Device code */
	deviceCode: string;
	/** When fitted */
	dateFitted: string;
	/** Who was it fitted by */
	fittedBy: string;
}

export interface VehicleDetails {
	/** Abi Code of vehicle */
	abiCode: string;
	/** Abi group for the vehicle */
	abiGroup: number;
	/** Annual mileage */
	annualMileage: number;
	/** Annual business mileage */
	businessMileage: number;
	/** Car body type code */
	bodyType: string;
	/** UK Vehicle Registration */
	registration: string;
	/** Vehicle Make */
	make: string;
	/** Vehicle Model */
	model: string;
	/** Number of doors on vehicle */
	numberOfDoors: string;
	/** Vehicle fuel type */
	fuelType: string;
	/** Transmission type */
	transmission: string;
	/** Gross Weight */
	grossWeight?: number;
	/** Cylinder capacity of engine */
	engineSize: number;
	/** Estimated value of vehicle */
	value: number;
	/** See vehicle lookup year */
	yearOfManufacture: number;
	/** Is left hand drive */
	isLeftHandDrive?: boolean;
	/** Date of vehicle purchase */
	datePurchased?: string;
	/** DVLA issues ‘Q’ registration numbers to vehicles whose age or identity is in doubt. */
	isQPlate?: boolean;
	/** Has the vehicle been imported from overseas */
	isImported?: boolean;
	/** Vehicle Use code */
	vehicleUse: string;
	/** See vehicle owner code */
	ownership: string;
	/** See vehicle keeper code */
	registeredKeeper: string;
	/** Date Vehicle was registed */
	registrationDate: string;
	/** Country of Registration */
	countryOfRegistration?: string | undefined;
	/** Number of seats */
	numberOfSeats: string;
	/** See vehicle storage codes */
	vehicleOvernight: string;
	overnightAddress?: Address;
	/** List of modifications */
	modifications?: Modification[] | undefined;
	/** List of security devices */
	securityDevices?: SecurityDevice[] | undefined;
	/** Selected Cover */
	coverDefinitionCode?: string | undefined;
	/** Telematic Device Information. */
	telematicsDeviceInformation?: string | undefined;
	/** Has Telematic Box */
	telematicsBox?: boolean;
	/** Licensing Authority Information */
	licencingAuthority?: string | undefined;
	/** Deliver operator i.e  Uber Eats */
	deliveryOperator?: string | undefined;
}

export interface ExistingCardPaymentMethod {
	id: string;
	last4Digits: string;
	vendor: CardVendor;
	isDefault: boolean;
}

export interface MakePaymentIntentResponse {
	paymentId: string;
	idempotencyKey: string;
	clientIp: string;
}

export interface GetClientDataResponse {
	/** The caller's IP address, used for the Braintree 3DS additionalInformation.ipAddress field. */
	clientIp: string;
}

export interface PaymentDetails {
	/** URL of payment page */
	clientReturnURL?: string | undefined;
	saveCard: boolean;
	/** Current code */
	currencyCode: string;
	/** Amount to be taken */
	amount: number;
	billingAddress: Address;
}

export interface TakeUpDetails {
	/** Underwriting Response Id. */
	underwritingResponseId: string;
	/** Underwriting option Id. */
	underwritingOptionId: string;
	/** The selected payment option code. */
	paymentCollectionOptionCode: string;
	selectedBalanceSettlementMethod: PaymentMethods;
}

export interface AddOn {
	name?: string | undefined;
	amount?: number;
}

export interface CoverLevel {
	name: string;
	description: string;
}

export interface DriverExcess2 {
	compulsoryAmount: number;
	dataPointId: string;
}

export interface Endorsement2 {
	name: string;
	description: string;
}

export interface FullPolicy {
	policyToken: string;
	policyNumber: string;
	policyholder: PolicyHolder;
	coverDetails: CoverDetails2;
	vehicleDetails: PolicyVehicleDetails;
	startDate: string;
	endDate: string;
	drivers: DriverDetails[];
	addOns: AddOn[];
	policyStatus: PolicyStatus;
	autoRenewal: boolean;
	product: Product;
	scheme?: string | undefined;
	productCode: string;
	organisationDetails?: OrganisationDetails;
	address: Address;
	renewalDetails?: RenewalDetails;
	renewalDeclined?: boolean | undefined;
	isShortTermPolicy: boolean;
	isMTAForSchemeDisallowed: boolean;
	isDirectDebitPaymentMethod: boolean;
	isAutoRenewalChangeBlocked: boolean;
	renewalDeclinedReason?: string | undefined;
	annualMileage?: number;
	isSubscriptionRestartAvailable?: boolean;
	nonFinancePolicy?: boolean;
	isMileageBasedPolicy?: boolean;
	readonly hasClaims?: boolean;
	mtaEligibility?: MtaEligibilityResponse;
	readonly isActive?: boolean;
}

export interface MtaEligibilityResponse {
	isEligible?: boolean;
	mtaIneligibilityReason?: MtaIneligibilityReason;
}

export enum MtaIneligibilityReason {
	None = 'None',
	Unspecified = 'Unspecified',
	NoPaymentDetails = 'NoPaymentDetails',
	HasMissedPayments = 'HasMissedPayments',
	PolicyPending = 'PolicyPending',
	PolicyRenewalTakenUp = 'PolicyRenewalTakenUp',
	PolicyDueForRenewal = 'PolicyDueForRenewal',
	PolicyEndOfProduct = 'PolicyEndOfProduct',
	PolicyCancelled = 'PolicyCancelled',
	PolicyCancellationPending = 'PolicyCancellationPending',
	PolicyExpired = 'PolicyExpired',
	PolicyQuote = 'PolicyQuote',
	ShortTermPolicyTypeInvalid = 'ShortTermPolicyTypeInvalid',
	SchemeDisallowed = 'SchemeDisallowed',
}

export interface OrganisationDetails {
	companyName: string;
	dateEstablished: string;
	staffContact: string;
}

export interface CoverDetails2 {
	coverType: string;
	premium: number;
	voluntaryExcess: number;
	compulsoryExcess: number;
	endorsements: Endorsement2[];
	driverExcesses: DriverExcess3[];
	deviceProvider?: string | undefined;
	operatingArea?: string | undefined;
	operator?: string | undefined;
}

export interface DriverExcess3 {
	compulsoryAmount: number;
	dataPointId: string;
}

export interface TransactionSummary {
	transactionId?: string | undefined;
	termStartDate?: string;
	termEndDate?: string;
	transactionStatusDescription?: string | undefined;
}

export interface PolicyHolder {
	firstName: string;
	lastName: string;
	email: string;
	address: Address;
}

export interface PolicyOverview {
	policyToken: string;
	policyNumber: string;
	vehicleMakeModel: string;
	vehicleRegistrationNumber: string;
	policyTransactions: PolicyTransactions;
	startDate: string;
	expiryDate: string;
	product: Product;
	scheme: string;
	productName: string;
	remainingDaysOfCover: string;
	policyStatus: PolicyStatus;
	autoRenewal: boolean;
	isShortTermPolicy: boolean;
	isMTAForSchemeDisallowed?: boolean;
	renewalDate?: string | undefined;
	renewalDeclined?: boolean | undefined;
	isSubscriptionRestartAvailable?: boolean;
	nonFinancePolicy?: boolean;
	isAutoRenewalChangeBlocked?: boolean;
}

export interface PolicyOverviewResponse {
	policyOverviews: PolicyOverview[];
	total: number;
}

export enum PolicyStatus {
	Active = 'Active',
	DueForRenewal = 'DueForRenewal',
	DueToExpire = 'DueToExpire',
	Expired = 'Expired',
	Cancelled = 'Cancelled',
	Quote = 'Quote',
	Pending = 'Pending',
	RenewalTakenUp = 'RenewalTakenUp',
	EndOfProduct = 'EndOfProduct',
	CancellationPending = 'CancellationPending',
}

export interface PolicyTransactions {
	activeTransctionId?: string | undefined;
	renewalTransaction?: TransactionSummary;
	futureMTATransactionId?: string[] | undefined;
	declinedRenewalTransaction?: TransactionSummary;
	pendingCancellationTransaction?: TransactionSummary;
}

export interface RenewalCoverDetails {
	voluntaryExcess: number;
	compulsoryExcess: number;
	endorsements: Endorsement2[];
	coverLevel: CoverLevel;
	startDate: string;
	endDate: string;
	driverExcesses: DriverExcess2[];
}

export interface RenewalDetails {
	policyHolder: PolicyHolder;
	vehicleDetails: VehicleDetails2;
	drivers: DriverDetails[];
	renewalCoverDetails: RenewalCoverDetails;
	transactionId: string;
}

export interface VehicleDetails2 {
	make: string;
	model: string;
	registrationNumber: string;
	vehicleUse: string;
	licencingAuthority?: string | undefined;
}

export interface PolicyVehicleDetails {
	/** UK Vehicle Registration */
	registration: string;
	/** Vehicle Make */
	make: string;
	/** Vehicle Model */
	model: string;
	vehicleUse: string;
	/** Annual mileage */
	annualMileage: number;
	/** The area where the taxi is licensed */
	licencingAuthority?: string | undefined;
	/** Vehicle Value */
	vehicleValue?: string | undefined;
}

export interface PolicyProblemDetails {
	policyExceptionReason?: PolicyExceptionReason;
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export enum PaymentProvider2 {
	STRIPE = 'STRIPE',
	BRAINTREE = 'BRAINTREE',
}

export enum PolicyExceptionReason {
	NO_POLICY_FOUND = 'NO_POLICY_FOUND',
	TOO_MANY_POLICIES_FOUND = 'TOO_MANY_POLICIES_FOUND',
	UNABLE_TO_REFRESH_POLICY_DETAILS = 'UNABLE_TO_REFRESH_POLICY_DETAILS',
	UNKNOWN = 'UNKNOWN',
	POLICY_EXPIRED = 'POLICY_EXPIRED',
	POLICY_PENDING = 'POLICY_PENDING',
	POLICY_PAYMENT_OVERDUE = 'POLICY_PAYMENT_OVERDUE',
}

export interface PaymentInstallmentsMessageModel {
	installmentNumber?: number;
	dueDate?: string;
	amount?: number;
}

export enum PaymentPlanType {
	PayInFull = 'PayInFull',
	SpTwo = 'SpTwo',
	SpThree = 'SpThree',
}

export interface ProblemDetails {
	type?: string | undefined;
	title?: string | undefined;
	status?: number | undefined;
	detail?: string | undefined;
	instance?: string | undefined;

	[key: string]: any;
}

export interface FileResponse {
	data: Blob;
	status: number;
	fileName?: string;
	headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
	override message: string;
	status: number;
	response: string;
	headers: { [key: string]: any };
	result: any;

	constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
		super();

		this.message = message;
		this.status = status;
		this.response = response;
		this.headers = headers;
		this.result = result;
	}

	protected isSwaggerException = true;

	static isSwaggerException(obj: any): obj is SwaggerException {
		return obj.isSwaggerException === true;
	}
}

function throwException(
	message: string,
	status: number,
	response: string,
	headers: { [key: string]: any },
	result?: any,
): any {
	if (result !== null && result !== undefined) throw result;
	else throw new SwaggerException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
	return obj && obj.isAxiosError === true;
}
